import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Game } from '../models/game';
import { ConfigService } from '../services/config.service';
import { GameBaseApi } from './game-base-api';
import { WrestballGameTeamStatistic } from '../models/wrestball-game-team-statistic';
import { WrestballGameStatistic } from '../models/wrestball-game-statistic';
import { WrestballGameLog } from '../models/wrestball-game-log';

@Injectable({providedIn: 'root'})
export class WrestballGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<WrestballGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/team_statistic/`).pipe(
      map(result => WrestballGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<WrestballGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/user_statistic/`).pipe(
      map(result => WrestballGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<WrestballGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/logs/`).pipe(
      map(result => WrestballGameLog.toFront(result))
    ).toPromise();
  }
}
